import {TemperatureReadingKind,TemperatureReadingSource} from './temperature-reading.js';

function required(value,label){
  const text=String(value??'').trim();
  if(!text)throw new TypeError(label+' is required');
  return text;
}

function numeric(value){
  const raw=required(value,'temperature').replace(',','.');
  const number=Number(raw);
  if(!Number.isFinite(number))throw new TypeError('temperature must be numeric');
  return number;
}

function scope(value){
  const key=required(value,'temperature scope');
  if(key==='chamber')return Object.freeze({readingKind:TemperatureReadingKind.CHAMBER,itemId:null});
  if(key.startsWith('item:')){
    const itemId=key.slice(5).trim();
    if(itemId)return Object.freeze({readingKind:TemperatureReadingKind.INTERNAL,itemId});
  }
  throw new TypeError('temperature scope is invalid');
}

export function quickTemperatureInput({scope:scopeValue,enteredValue}={}){
  const target=scope(scopeValue);
  const value=numeric(enteredValue);
  const [min,max]=target.readingKind===TemperatureReadingKind.CHAMBER?[-100,600]:[-100,300];
  if(value<min||value>max){
    throw new RangeError(target.readingKind===TemperatureReadingKind.CHAMBER
      ?'chamber temperature must be between -100 and 600 C'
      :'internal temperature must be between -100 and 300 C');
  }
  return Object.freeze({
    readingKind:target.readingKind,
    itemId:target.itemId,
    enteredValue:value,
    enteredUnit:'C',
    sourceType:TemperatureReadingSource.MANUAL
  });
}

export function quickTemperatureInputFromForm(formData){
  if(!formData?.get)throw new TypeError('FormData is required');
  return quickTemperatureInput({
    scope:formData.get('temperatureScope'),
    enteredValue:formData.get('temperatureValue')
  });
}

export function quickTemperatureErrorText(error){
  const message=String(error?.message||'');
  if(message.includes('temperature is required'))return 'Wpisz temperaturę.';
  if(message.includes('must be numeric'))return 'Wpisz prawidłową wartość temperatury.';
  if(message.includes('chamber temperature'))return 'Temperatura komory musi mieścić się w zakresie od -100°C do 600°C.';
  if(message.includes('internal temperature'))return 'Temperatura produktu musi mieścić się w zakresie od -100°C do 300°C.';
  if(message.includes('scope'))return 'Wybierz komorę albo produkt.';
  return 'Nie udało się zapisać temperatury. Sprawdź wartość i spróbuj ponownie.';
}
